import math from '@/utils/math.js'
import { rsaEncrypt, rsaSign, cryptoJSAesEncrypt ,cryptoJSAesDecrypt, generateRandomString } from '@/utils/encrypt'
import { validateFormAmount } from '@/utils/validate'

function filterEmptyAttr(params = {}) {
  const newParam = {}
  Object.keys(params).filter(item => params[item] || params[item] === 0).forEach((key) => {
    let value = params[key]
    if (typeof value === 'string') {
      value = value.trim()
    }
    newParam[key] = value
  })
  return newParam
}

/*
  project use： $commonFn.mathMultiply(amount, 100)
*/
function mathMultiply(a, b){
  a = Number(a)
  b = Number(b)
  let multipliedAmount = math.multiply(a, b);
  let result = multipliedAmount.valueOf();
  return +result

}

/*
  $commonFn.mathDivide(amount, 100)
*/
function mathDivide(a, b){
  a = Number(a)
  b = Number(b)
  let divideAmount = math.divide(a, b);
  let result = divideAmount.valueOf();
  return +result

}

// function dateLimit(that,days){
//   let startDate
//   let endDate
//   return {
//     onPick:(selectedDate) =>{
//       that.$nextTick(()=>{
//         startDate = selectedDate.minDate ? new Date(selectedDate.minDate) : null;
//         endDate = selectedDate.minDate ? new Date(selectedDate.minDate) : null;
//         if (startDate) {
//           startDate = new Date(startDate).getTime() - (days * 86400000)
//           endDate = new Date(endDate).getTime() + (days * 86400000)
//         }
//       })
//     },
//     disabledDate: (date) => {
//       date =  new Date(date).getTime()
//       return (
//         (startDate && date < startDate) || (endDate && date > endDate)
//       );
//     }
//   };
// }


function dateSplit(date){
  if(!date || typeof date !== 'string'){
    return []
  }
  let dateArr = date.split(' ')
  return dateArr
}


function dateLimit(that,days){
  let startDate
  let endDate
  days = days -1
  return {
    onPick:(selectedDate) =>{
      that.$nextTick(()=>{
        startDate = selectedDate.minDate ? new Date(selectedDate.minDate) : null;
        endDate = selectedDate.minDate ? new Date(selectedDate.minDate) : null;
        if (startDate) {
          startDate.setDate(startDate.getDate() - days);
          endDate.setDate(endDate.getDate() + days);
        }
      })
    },
    disabledDate: (date) => {
      return (
        (startDate && date < startDate) || (endDate && date > endDate)
      );
    }
  };
}


function checkSubmitDateLimit(date, days) {
  if (Array.isArray(date) && date.length > 0) {
    const date1 = new Date(date[0])
    const date2 = new Date(date[1])
    const timeDiff = date2.getTime() - date1.getTime()
    const diffDays = timeDiff / (1000 * 3600 * 24)
    if (diffDays >= days) {
      return false
    }
  }
  return true
}

function getPlatformValue(obj) {
  // 根据不同平台环境变量返回不同的组件名
  const platform = (process.env.VUE_APP_PLATFORM || '').toLowerCase()
  // 如果有对应的组件名就返回，否则返回默认
  return obj[platform] || obj.default
}


export default {
  filterEmptyAttr,
  mathMultiply,
  mathDivide,
  dateLimit,
  checkSubmitDateLimit,
  dateSplit,
  rsaEncrypt,
  rsaSign,
  cryptoJSAesEncrypt,
  cryptoJSAesDecrypt,
  generateRandomString,
  getPlatformValue,
  validateFormAmount
}



